import React from 'react';
import { Card, message, Button } from 'antd';
import QueueAnim from 'rc-queue-anim';
import axios from '../../axios/index';
export default class Artical extends React.Component {
    state = {
        show: false,
        artical: []
    }
    params = {
        page: 1
    }
    componentDidMount() {
        let id = this.props.match.params.artid;
        let self = this;
        setTimeout(() => {
            self.setState({
                show: !self.state.show
            })
        }, 200);

        axios.ajax({
            url: '/contents/GetById',
            data: {
                params: {cid: Number(id)}
            }
        }).then(res => {
            console.log(res)
            if (res.code !== '200') {
                message.error(res.message, 3);
                return;
            }
            self.state.artical.push(res.data);
            let artical = self.renderListArt();
            self.setState({
                artical: artical
            })
        })
    }

    renderListArt = () => {
        return this.state.artical.map( item =>
            <Card bordered={false} title={item.title} key={item.cid}>
                {item.content}
            </Card>
        )
    }

    handleReadContent = (id) => {
        console.log(id)
    }

    render() {
        return (
            <div>
                <QueueAnim>
                    {
                        this.state.show ? [
                            this.state.artical
                        ] : null
                    }
                </QueueAnim>
            </div>
        );
    }
}